import { Action, Dispatch } from "redux";
import { FGetState } from "../app.reducer";
import { KeyVmDto } from "dto/vending/KeyVmDto";
import { ScanYearOldDto } from "dto/vending/ScanYearOldDto";

/**
 * Functon type declare
 */
export type FuncAction = (
	dispatch: Dispatch,
	getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
	APP: {
		KEY_VM: "APP_KEY_VM",
		SCAN_YEAR_OLD: "SCAN_YEAR_OLD",
		CLEAR_STATE: "APP_CLEAR_STATE",
	},

}

/**
 * All app state 
 */
export interface AppState {
	keyVMList: Array<KeyVmDto>,
	lastDataScanYearOld: ScanYearOldDto,
}

/**
 * App's action definition
 */
export interface IAppAction extends Action {
	payload: any;
}
